// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let afflictionRuleEnum = {
    'None': 0,
    'Varroa': 1,
    'AmericanFoulbrood': 2
};

export default afflictionRuleEnum;
